"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const currency_1 = require("../../../../app/shared/utils/currency");
const useSimulationStore_1 = require("../../../../stores/useSimulationStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'trim-list-item',
    props: {
        powerTrain: null
    },
    setup(__props) {
        const props = __props;
        const store = (0, useSimulationStore_1.useSimulationStore)();
        const url = (0, vue_2.computed)(() => {
            const link = new URL(window.location.href);
            link.searchParams.set("power-train", props.powerTrain.power_train_id);
            return link.href;
        });
        return { __sfc: true, store, props, url, parseToMexicanPeso: currency_1.parseToMexicanPeso };
    }
});
